import { UserRole } from './user.model';

/** Libellés français des rôles de CDT, tels que la direction les lit dans l'application. */
export const userRoleLabels: Record<UserRole, string> = {
  'assistant-de-production': 'Assistant de production',
  'administration-du-personnel': 'Administration du personnel',
  'responsable-exploitation': "Responsable d'exploitation",
  'responsable-paie': 'Responsable paie',
  'directeur-rh': 'Directeur RH',
  'responsable-rh': 'Responsable RH',
  'directeur-agence': "Directeur d'agence",
  'directeur-admin-financier': 'Directeur administratif et financier',
  'directeur-general': 'Directeur général',
  'directeur-production': 'Directeur de production',
  'cdt-process-manager': 'Gestionnaire des processus CDT',
};

/** Libellé d'un rôle ; un rôle que l'application ne connaît pas garde son nom technique. */
export function userRoleLabel(role: string): string {
  return userRoleLabels[role as UserRole] ?? role;
}
